import {CommonModule} from '@angular/common';
import {MaterialModule} from '../../../../material/material.module';
import {NgModule} from '@angular/core';
import {SalePointPlirotisSecondStepComponent} from './sale-point-plirotis-second-step.component';

@NgModule({
  declarations: [SalePointPlirotisSecondStepComponent],
  exports: [SalePointPlirotisSecondStepComponent],
  imports: [
    CommonModule,
    MaterialModule
  ]
})

export class SalePointPlirotisSecondStepModule {
}
